import script from "./goRinSyo0030.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0030.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0030.vue?vue&type=style&index=0&id=67ea20ff&lang=scss"

const __exports__ = script;

export default __exports__